import { jsx as _jsx } from "react/jsx-runtime";
export const PlayXs = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            fill: color,
            d: "M3.25 2.821c0-1.38 1.525-2.217 2.69-1.475l8.137 5.177a1.75 1.75 0 0 1 0 2.954L5.94 14.654c-1.164.742-2.689-.095-2.689-1.475zm1.5 10.358a.25.25 0 0 0 .384.21l8.137-5.178a.25.25 0 0 0 0-.422L5.134 2.61a.25.25 0 0 0-.384.211z"
        })
    });

//# sourceMappingURL=play-xs.js.map